'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  landingPageEvent,
  ElectronicsBottomSectionModel,
  ElectronicsBottomCtaClickEvents,
  ElectronicsBottomLinkClickEvents,
  ElectronicsLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import useElectronicsLpVersion from '../../hooks/useElectronicsLpVersion'

type Props = { content: ElectronicsBottomSectionModel }

const BottomSection = ({
  content: { title, description, ctaText, ctaUrl, linkText, linkUrl },
}: Props) => {
  const { track } = useTracking()
  const lpVersion = useElectronicsLpVersion()

  const clickAction = async (event: ElectronicsLandingPageEvent, targetDetails: string) => {
    track(
      landingPageEvent({
        event,
        targetDetails,
        deviceId: await getFingerprint(),
      }),
    )
  }

  const handleOnLinkClick = async () =>
    clickAction(ElectronicsBottomLinkClickEvents[lpVersion], linkUrl)

  const handleOnCtaClick = async () =>
    clickAction(ElectronicsBottomCtaClickEvents[lpVersion], ctaUrl)

  return (
    <section data-testid="bottom-section" className="electronics__bottom-section">
      <h2 className="electronics__bottom-title">{title}</h2>
      <p className="electronics__bottom-description">{description}</p>
      <div className="electronics__bottom-cta">
        <Button
          size="default"
          styling="filled"
          text={ctaText}
          url={ctaUrl}
          testId="electronics-bottom-cta"
          onClick={handleOnCtaClick}
        />
      </div>
      <div className="electronics__bottom-link">
        <a href={linkUrl} onClick={handleOnLinkClick} data-testid="electronics-bottom-link">
          {linkText}
        </a>
      </div>
    </section>
  )
}

export default BottomSection
